'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-undef */
var isMobile = function isMobile() {
  if (typeof navigator !== 'undefined') {
    return navigator.userAgent.search(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i) !== -1;
  }

  return null;
};

exports.default = isMobile;